(function () {
  function getPerView() {
    if (window.matchMedia('(max-width: 520px)').matches) return 1;
    if (window.matchMedia('(max-width: 1000px)').matches) return 2;
    return 4;
  }

  function initPopularCarousel(root) {
    if (root.dataset.popReady === '1') return;
    root.dataset.popReady = '1';

    var viewport = root.querySelector('[data-pop-viewport]');
    var track = root.querySelector('[data-pop-track]');
    var dotsWrap = root.querySelector('[data-pop-dots]');
    if (!viewport || !track || !dotsWrap) return;

    var cards = track.children;
    if (!cards.length) return;

    var index = 0;
    var timer = null;
    var gap = 24;
    var delay = parseInt(root.getAttribute('data-autoplay-ms') || '6000', 10);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pageCount() {
      return Math.max(1, Math.ceil(cards.length / getPerView()));
    }

    function pageWidth() {
      return viewport.clientWidth;
    }

    function cardWidth() {
      var perView = getPerView();
      var vw = pageWidth();
      if (perView <= 1) return vw;
      return (vw - gap * (perView - 1)) / perView;
    }

    function rebuildDots() {
      var count = pageCount();
      dotsWrap.innerHTML = '';
      if (count <= 1) {
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gh-pop__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('data-pop-dot', '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
        btn.addEventListener('click', (function (n) {
          return function () {
            goTo(n);
            start();
          };
        })(i));
        dotsWrap.appendChild(btn);
      }
    }

    function updateDots() {
      var dots = dotsWrap.querySelectorAll('[data-pop-dot]');
      dots.forEach(function (dot, n) {
        var active = n === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function goTo(i) {
      var pages = pageCount();
      index = ((i % pages) + pages) % pages;
      var cw = cardWidth();
      var perView = getPerView();
      var offset = index * (cw + gap) * perView;
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      updateDots();
    }

    function layout() {
      var cw = cardWidth();
      Array.prototype.forEach.call(cards, function (card) {
        card.style.flexBasis = cw + 'px';
        card.style.maxWidth = cw + 'px';
      });
      rebuildDots();
      goTo(Math.min(index, pageCount() - 1));
    }

    function next() {
      goTo(index + 1);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (reduced || delay <= 0 || pageCount() <= 1) return;
      timer = setInterval(next, delay);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 120);
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    layout();
    start();
  }

  function boot() {
    document.querySelectorAll('[data-pop-carousel]').forEach(initPopularCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
